<template>
  <div class="mx-auto mt-18 md:w-2/3 w-full p-8">
    <h1 class="font-bold text-4xl">Glömt lösenord?</h1>

    <form :action="passwordsPath" method="post">
      <input type="hidden" name="authenticity_token" :value="csrfToken" />

      <div class="my-5">
        <Label>E-post</Label>
        <Input
          type="email"
          name="email_address"
          required
          autofocus
          autocomplete="username"
          placeholder="Ange din e-postadress"
          class="mt-2"
        />
      </div>

      <Button type="submit">Skicka återställning e-mail</Button>
    </form>
  </div>
</template>

<script setup>
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

defineProps({
  csrfToken: { type: String, required: true },
  passwordsPath: { type: String, required: true },
});
</script>
